import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { FaEdit } from "react-icons/fa";
import { Icon, Pagination } from "semantic-ui-react";

import { limpaTituloCurso } from "../../../../utils/Utils";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Back from "../../../../components/Admin/Parceiros/Pedidos/Back";
import Loading from "../../../../components/Loader";

import {
  Container,
  Content,
  Title,
  SemanticTable,
  Layer,
  Modal,
  Form,
  Group,
  Label,
  InputModal,
  ButtonModal,
  BoxButton,
  Select,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";

const GerenciarCursosPersonalite = () => {
  const [cursosDestaque, setCursosDestaque] = useState(null);
  const [modalEdit, setModalEdit] = useState(false);
  const [loading, setLoading] = useState(false);

  const [listaCursos, setListaCursos] = useState([]);
  const [listaCategorias, setListaCategorias] = useState([]);

  const [idDestaqueUpdate, setIdDestaqueUpdate] = useState(null);
  const [idPersonaliteUpdate, setIdPersonaliteUpdate] = useState(null);
  const [idCursoUpdate, setIdCursoUpdate] = useState(null);
  const [ordemUpdate, setOrdemUpdate] = useState(null);

  const [reload, setRelaod] = useState(false);

  useEffect(() => {
    setLoading(true);
    api
      .get(`/cursos-destaque-personalite`)
      .then((response) => {
        if (response.data) {
          setCursosDestaque(response.data);
        } else {
          alert(response.message);
        }

        setLoading(false);
      })
      .catch((err) => console.error(err));
  }, [reload]);

  useEffect(() => {
    api
      .get(`/cursos-simplelistAll`)
      .then((response) => {
        if (response.data) {
          setListaCursos(response.data);
        } else {
          alert(response.message);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    api
      .get("/categories-personalite")
      .then((response) => {
        setListaCategorias(response.data.categories);
      })
      .catch((err) => console.error(err));
  }, []);

  const updateDestaque = (e) => {
    e.preventDefault();
    const data = {
      id_personalite: idPersonaliteUpdate,
      id_curso: idCursoUpdate,
      ordem: ordemUpdate,
    };

    api
      .put(`admin/curso-destaque-personalite/${idDestaqueUpdate}`, data, {
        headers: {
          access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
        },
      })
      .then((response) => {
        if (response.data) {
          let logs = { local: 'PersonaliteCursosDestaques', texto: `editou o curso destaque personalite` };
          api.post('system_logs',
            { acao: JSON.stringify(logs) }
          );
          swal({
            title: "Alteração realizada com sucesso!",
            text: `Você alterou o curso destaque Personalite com sucesso`,
            icon: "success",
            button: "Ok !",
          });
        }

        setRelaod(!reload);
      })
      .catch((err) => console.error(err));

    setModalEdit(false);
  };

  const handleModalEdit = (destaque) => {
    setIdCursoUpdate(destaque.id_curso);
    setIdPersonaliteUpdate(destaque.id_personalite);
    setIdDestaqueUpdate(destaque.id);
    setOrdemUpdate(destaque.ordem);
    setModalEdit(true);
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Back />
          <Title>
            Gerencimento dos cursos destaques/recomendadados Personalite
          </Title>

          {loading ? (
            <div>
              <Loading />
            </div>
          ) : (
            <>
              <SemanticTable size="big" celled>
                <SemanticTable.Header>
                  <SemanticTable.Row>
                    <SemanticTable.HeaderCell> ID </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>
                      ID Área Personalite
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>
                      Curso Destaque
                    </SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Ordem</SemanticTable.HeaderCell>
                    <SemanticTable.HeaderCell>Editar</SemanticTable.HeaderCell>
                  </SemanticTable.Row>
                </SemanticTable.Header>
                <SemanticTable.Body>
                  {cursosDestaque
                    ? cursosDestaque.map((destaque, index) => (
                      <SemanticTable.Row key={index}>
                        <SemanticTable.Cell>{destaque.id}</SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {destaque.id_personalite} -{" "}
                          {destaque.personalite.name}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {destaque.id_curso} -
                            {destaque.curso
                            ? limpaTituloCurso(destaque.curso.curso)
                            : null}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          {destaque.ordem}
                        </SemanticTable.Cell>
                        <SemanticTable.Cell>
                          <FaEdit onClick={() => handleModalEdit(destaque)} />
                        </SemanticTable.Cell>
                      </SemanticTable.Row>
                    ))
                    : null}
                </SemanticTable.Body>
              </SemanticTable>

              {modalEdit ? (
                <>
                  <Layer>
                    <Modal>
                      <Form>
                        <Group>
                          <Label> ID Personalite </Label>{" "}
                          {listaCategorias ? (
                            <Select
                              defaultValue={idPersonaliteUpdate}
                              onChange={(e) =>
                                setIdPersonaliteUpdate(parseInt(e.target.value))
                              }
                            >
                              {listaCategorias.map((categoria, key) => (
                                <option key={key} value={categoria.id}>
                                  {categoria.id} - {categoria.name}
                                </option>
                              ))}
                            </Select>
                          ) : null}
                        </Group>
                        <Group>
                          <Label> ID Curso </Label>
                          {listaCursos ? (
                            <Select
                              defaultValue={idCursoUpdate}
                              onChange={(e) =>
                                setIdCursoUpdate(parseInt(e.target.value))
                              }
                            >
                              {listaCursos.map((curso, key) => (
                                <option key={key} value={curso.id}>
                                  {curso.id} - {curso.curso}
                                </option>
                              ))}
                            </Select>
                          ) : null}
                        </Group>
                        <Group>
                          <Label> Ordem </Label>{" "}
                          <InputModal
                            type={"number"}
                            value={ordemUpdate}
                            onChange={(e) => setOrdemUpdate(e.value)}
                          />
                        </Group>
                        <BoxButton>
                          <ButtonModal
                            onClick={() => setModalEdit(false)}
                            background={"red"}
                          >
                            Cancelar
                          </ButtonModal>
                          <ButtonModal
                            background={"green"}
                            onClick={(e) => updateDestaque(e)}
                          >
                            Salvar
                          </ButtonModal>
                        </BoxButton>
                      </Form>
                    </Modal>
                  </Layer>
                </>
              ) : null}
            </>
          )}
        </Content>
      </Container>
    </>
  );
};

export default withRouter(GerenciarCursosPersonalite);
